// Fuel English translations
export const fuelEn = {
  'add.fuel.receipt': 'Add Fuel Receipt',
  'all.vehicles.fuel.efficiency': 'Fuel Efficiency - All Vehicles',
  'recalculate.last.30.days': 'Recalculate Last 30 Days',
  'create.fuel.receipt': 'Create Fuel Receipt',
  'continue.anyway': 'Do you want to continue?',
  'duplicate.receipt.warning': 'Duplicate Receipt Number',
  'edit.fuel.receipt': 'Edit Fuel Receipt',
  'efficiency.liters.per.100km': 'Liters/100km',
  'error.saving.fuel.receipt': 'Error saving fuel receipt',
  'existing.record': 'Existing Record',
  'fuel.cost': 'Fuel Cost',
  'fuel.efficiency': 'Fuel Efficiency',
  'fuel.efficiency.calculator': 'Fuel Efficiency Calculator',
  'fuel.efficiency.chart': 'Fuel Efficiency Chart',
  'fuel.efficiency.history': 'Fuel Efficiency History',
  'fuel.efficiency.summary': 'Fuel Efficiency Summary',
  'fuel.receipt.created': 'Fuel receipt created successfully',
  'fuel.receipt.management': 'Fuel Receipt Management',
  'fuel.receipt.saved.as.draft': 'Fuel receipt saved as draft',
  'fuel.receipt.updated': 'Fuel receipt updated successfully',
  'fuel.tank.capacity': 'Fuel Tank (L)',
  'gas.station': 'Gas Station',
  'link.fuel.receipt': 'Link Fuel Receipt',
  'linked.fuel.receipts': 'Linked Fuel Receipts',
  'liters': 'Liters',
  'no.fuel.receipts.linked': 'No fuel receipts linked',
  'no.unlinked.fuel.receipts': 'No unlinked fuel receipts available',
  'odometer': 'Odometer',
  'odometer.reading': 'Odometer Reading',
  'please.enter.valid.liters': 'Please enter valid liters',
  'receipt.number': 'Receipt Number',
  'receipt.number.already.exists': 'Receipt number',
  'already.exists.in.database': 'already exists in the database',
  'refuel.date': 'Refuel Date',
  'requires.odometer.readings': 'Requires at least 2 receipts with odometer readings',
  'select.fuel.receipt.to.link': 'Select a fuel receipt to link',
  'total.fuel': 'Total Fuel',
  'total.fuel.cost': 'Total Fuel Cost',
  'upload.fuel.receipt.image': 'Upload Fuel Receipt Image',
  'view.fuel.efficiency': 'View Fuel Efficiency',
  'view.fuel.receipts': 'View Fuel Receipts',
};
